import React from "react";
import styles from "./confirmationTeenGame.module.css";
import BoxSettings from "../../components/boxSettings/boxSettings";
import { useTranslation } from "react-i18next";


const SettingsTeenGame = ({abortFunction}) => {
  const { t } = useTranslation();
  const settings_options = t("settings.settings", { returnObjects: true });
  
  return (
    <div className={styles.wrapperConfirmation}>
      <div onClick={() => abortFunction()}  className={styles.overlayConfirmation}></div>

     <BoxSettings 
        call={t("settings.box_call")}
        confirm={t("settings.confirm")}
        handleCompletion={abortFunction}
        hdelay={"0ms"}
        settingsOptions={settings_options}
      />
      
    </div>   
  );
};

export default SettingsTeenGame;
